<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t('sideMenu.contactSupport') }}</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <div class="message-form">
                                <base-input :label="$t('general.subject')" v-model="subject"></base-input>
                                <base-input :label="$t('general.message')">
                                    <textarea class="form-control" v-model="message" rows="3"></textarea>
                                </base-input>
                                <base-button
                                    type="success"
                                    :loading="emailIsSending"
                                    @click="sendMessage">
                                    {{ emailIsSending ? $t('general.sending') : $t('general.send') }}
                                </base-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'contact-support',
        data() {
            return {
                subject: null,
                message: null,
                emailIsSending: false,
            }
        },
        methods: {
            sendMessage() {
                this.emailIsSending = true;
                this.$axios.post('/api/contact-support', {
                    subject: this.subject,
                    message: this.message,
                })
                    .then(() => {
                        this.$notify({
                            title: this.$t('general.messageSent'),
                        });
                        this.subject = null;
                        this.message = null;
                    })
                    .catch(({response}) => {
                        this.$notify({
                            title: response.data.message,
                            type: 'danger',
                        });
                    })
                    .then(() => {
                        this.emailIsSending = false;
                    })
            },
        },
    };
</script>
<style lang="scss">
    .message-form {
        max-width: 750px;
    }
</style>
